import 'react-on-rails-pro/registerDefaultRSCProvider/client';
import ReactOnRails from 'react-on-rails-pro/client';
import RestaurantDetailSSR from '../../startup/RestaurantDetailSSR.tsx';

ReactOnRails.register({RestaurantDetailSSR});